import { IFacet, IFacetSelections } from '../../types/facets'

type OnChangeFacetSelections = (facetSelections: IFacetSelections) => void

/** Helper function that modifies the selected facets in a filter */
export const onSelectById = (
  id: string,
  selections: string[],
  facets: IFacet[],
  facetSelections: IFacetSelections,
  onChange: OnChangeFacetSelections
): void => {
  const updatedSelections = facets.flatMap(facet => {
    if (facet.id === id) {
      return {
        id,
        selections,
      }
    }
    return (
      facetSelections.find(facetSelection => facetSelection.id === facet.id) ??
      []
    )
  })
  onChange(updatedSelections)
}

/** Helper function that modifies the selected facets in a filter */
export const onSelectByLabel = (
  id: string,
  selections: string[],
  facets: IFacet[],
  facetSelections: IFacetSelections,
  onChange: OnChangeFacetSelections
): void => {
  const updatedSelections = facets.flatMap(facet => {
    if (facet.id === id) {
      return {
        id,
        selections: facet.options
          .filter(option => selections.includes(option.label))
          .map(option => option.id),
      }
    }
    return (
      facetSelections.find(facetSelection => facetSelection.id === facet.id) ??
      []
    )
  })
  onChange(updatedSelections)
}

/** Helper function that clears all the selected facets in a filter */
export const onClear = (
  facets: IFacet[],
  onChangeFacetSelections: OnChangeFacetSelections
): void => {
  onChangeFacetSelections(
    facets.map(facet => ({
      id: facet.id,
      selections: [],
    }))
  )
}
